export function formatString(input: string): string {
  const result = input
    ?.toLowerCase()
    ?.split('_')
    ?.map((word, index) =>
      index === 0 ? word?.charAt(0)?.toUpperCase() + word?.slice(1) : word?.toUpperCase()
    )
    ?.join(' ');

  return result;
}
